export default __webpack_public_path__ + "static/media/WoodMahoganyAfricanSanded0WEB.98af91d1.jpg";